/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/
import spacing from '../scss/spacing.module.scss';

type Spacing = {
  space_none: string;
  space_4xs: string;
  space_3xs: string;
  space_2xs: string;
  space_xs: string;
  space_s: string;
  space_sm: string;
  space_m: string;
  space_l: string;
  space_xl: string;
  space_2xl: string;
  space_3xl: string;
  space_4xl: string;
  space_5xl: string;
  space_6xl: string;
  space_7xl: string;
};

/**
 * Export Spacing tokens
 * @public
 */
export default spacing as unknown as Spacing;
